<template>
  <NuxtLayout>
    <div v-if="loading" class="app-loading">
      <div class="spinner">
        <i class="esei icon-apple-whole-solid spin-icon" 
         style="color:#5bab42; font-size: 70px;" aria-hidden="true"></i>
      </div>
    </div>

    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>
import { ref } from 'vue'

const loading = ref(false)

if (process.client) {
  const nuxtApp = useNuxtApp()

  nuxtApp.hook('page:start', () => { loading.value = true })
  nuxtApp.hook('page:finish', () => { loading.value = false })
}
</script>

 